// „Още" — второстепенните инструменти, извадени от долната лента.
// Групирани по смисъл, за да не са разхвърляни: документи/пари, обяви,
// профил/акаунт. Достъпен като таб от долната навигация.

import React from 'react';
import { Pressable, ScrollView, Text, View } from 'react-native';
import { useAuth } from '../AuthContext';
import { confirmAction } from '../toast';
import { COLORS } from '../ui';
import { t } from '../i18n';

type Item = { icon: string; label: string; screen: string };
type Group = { title: string; items: Item[] };

// Функция, за да се преведат етикетите при смяна на езика
function getGroups(): Record<string, Group[]> {
  const GROUPS: Record<string, Group[]> = {
    LANDLORD: [
      {
        title: t('Пари и документи'),
        items: [
          { icon: '📄', label: t('Документи'), screen: 'Documents' },
          { icon: '🧾', label: t('Фактури'), screen: 'Invoices' },
          { icon: '⭐', label: t('Абонамент'), screen: 'Subscription' },
        ],
      },
      {
        title: t('Имоти и наематели'),
        items: [
          { icon: '🛠️', label: t('Нередности и ремонти'), screen: 'Issues' },
          { icon: '🔎', label: t('Свободни апартаменти'), screen: 'Listings' },
          { icon: '🔍', label: t('Провери наемател'), screen: 'Reputation' },
          { icon: '🗄️', label: t('Архивирани имоти'), screen: 'ArchivedApartments' },
        ],
      },
      {
        title: t('Акаунт'),
        items: [
          { icon: '🔔', label: t('Известия'), screen: 'Notifications' },
          { icon: '👤', label: t('Профил'), screen: 'Profile' },
        ],
      },
    ],
    TENANT: [
      {
        title: t('Документи'),
        items: [
          { icon: '📄', label: t('Документи'), screen: 'Documents' },
          { icon: '🧾', label: t('Фактури'), screen: 'Invoices' },
        ],
      },
      {
        title: t('Търсене'),
        items: [
          { icon: '🔎', label: t('Свободни апартаменти'), screen: 'Listings' },
          { icon: '🔍', label: t('Провери наемател'), screen: 'Reputation' },
        ],
      },
      {
        title: t('Акаунт'),
        items: [
          { icon: '🔔', label: t('Известия'), screen: 'Notifications' },
          { icon: '👤', label: t('Профил'), screen: 'Profile' },
        ],
      },
    ],
  };
  GROUPS.AGENCY = GROUPS.LANDLORD;
  return GROUPS;
}

export default function MoreScreen({ navigation }: any) {
  const { user, signOut } = useAuth();
  const groups = getGroups()[user?.role ?? ''] ?? [];

  return (
    <ScrollView style={{ flex: 1, backgroundColor: COLORS.bg }} contentContainerStyle={{ padding: 16, paddingBottom: 40 }}>
      <View style={{ width: '100%', maxWidth: 640, alignSelf: 'center' }}>
        {groups.map((group) => (
          <View key={group.title} style={{ marginBottom: 22 }}>
            <Text style={{ fontSize: 13, fontWeight: '700', color: COLORS.muted, letterSpacing: 0.4, textTransform: 'uppercase', marginBottom: 8, marginLeft: 4 }}>
              {group.title}
            </Text>
            <View style={{ backgroundColor: COLORS.card, borderRadius: 14, borderWidth: 1, borderColor: COLORS.border, overflow: 'hidden' }}>
              {group.items.map((item, i) => (
                <Pressable
                  key={item.screen}
                  onPress={() => navigation.navigate(item.screen)}
                  style={({ pressed }) => ({
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 12,
                    paddingVertical: 15,
                    paddingHorizontal: 16,
                    borderTopWidth: i === 0 ? 0 : 1,
                    borderTopColor: COLORS.border,
                    backgroundColor: pressed ? COLORS.bg : 'transparent',
                  })}
                >
                  <Text style={{ fontSize: 19 }}>{item.icon}</Text>
                  <Text style={{ fontSize: 16, color: COLORS.text, fontWeight: '500', flex: 1 }}>{item.label}</Text>
                  <Text style={{ color: COLORS.muted, fontSize: 18 }}>›</Text>
                </Pressable>
              ))}
            </View>
          </View>
        ))}

        <Pressable
          onPress={() =>
            confirmAction(t('Изход'), t('Наистина ли излизате от акаунта?'), t('Изход'), signOut)
          }
          style={({ pressed }) => ({
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            paddingVertical: 15,
            borderRadius: 14,
            borderWidth: 1,
            borderColor: COLORS.border,
            backgroundColor: pressed ? COLORS.bg : COLORS.card,
          })}
        >
          <Text style={{ fontSize: 18 }}>🚪</Text>
          <Text style={{ fontSize: 16, color: COLORS.danger, fontWeight: '600' }}>{t('Изход от акаунта')}</Text>
        </Pressable>
      </View>
    </ScrollView>
  );
}
